<template>
    <div class="courses_home">
        <div class="courses1">
            <div class="c1_cont">
                <div class="cn">艺术课程</div>
                <div class="en">ART COURSE</div>
            </div>
        </div>

        <div class="courses2">
            <div class="c2_cont">
                <div class="swiper mySwiperC1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title c2_title1">
                                    <div>专业作品集辅导</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>已具备基础课能力的学生，计划申请艺术设计院校本科、研究生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>多名艺术导师量身制定作品集产出</li>
                                            <li><span></span>海外高等院校教学模式</li>
                                            <li><span></span>四级教学法+五维审核体系</li>
                                            <li><span></span>多元化竞赛资源</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/sample.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title2 c2_title">
                                    <div>A-LEVEL辅导</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>16 — 19 周岁（ 初中毕业 / 高中在读 ）</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>官方认证的A Level办学&考试中心</li>
                                            <li><span></span>为英联邦艺术留学申请定制</li>
                                            <li><span></span>灵活的选课机制助学生扬长避短</li>
                                            <li><span></span>开设多门艺术学科，多维度拓展艺术知识</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/alevel.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title3 c2_title">
                                    <div>VIP院校计划</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>申请艺术设计院校本科、研究生的学生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>定制化全套作品集课程</li>
                                            <li><span></span>海外教授多V1辅导</li>
                                            <li><span></span>欧美权威专业TOP3、TOP5、TOP8名校OFFER</li>
                                            <li><span></span>梦校直通车</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/vip.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title4 c2_title">
                                    <div>海外游学与夏校项目</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>15周岁以上高中或大学生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>与海外导师合作，独家定制课程</li>
                                            <li><span></span>沉浸式体验，探索灵感来源</li>
                                            <li><span></span>实际前往院校，深入名校课堂</li>
                                            <br>


                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/promoting')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title5 c2_title">
                                    <div>BTEC艺术设计预科</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>16周岁及以上，高中毕业或在读学生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>官方认证BTEC办学&考试中心</li>
                                            <li><span></span>本科直录核心课程</li>
                                            <li><span></span>提前适应国外艺术教育模式</li>
                                            <li><span></span>证书全球认可、学分终身有效</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/btec.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title6 c2_title">
                                    <div>GA&GD创意基础课</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>12-16周岁</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>艺术设计启蒙课程</li>
                                            <li><span></span>启发并引导自主的艺术创作</li>
                                            <li><span></span>系统地培养艺术思维</li>
                                            <li><span></span>提升艺术审美与创造力</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/gagd.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>

                        <div class="swiper-slide">
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title7 c2_title">
                                    <div>AP课程</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>申请艺术院校的高中生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>助力美本直录</li>
                                            <li><span></span>成绩可抵扣本科学分</li>
                                            <li><span></span>官方审核评估机制</li>
                                            <li><span></span>AP成绩与作品集双重把控</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/ap.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                            <div class="c2_item">
                                <div class="c2_tuoyuan"></div>
                                <div class="c2_blue_line"></div>
                                <div class="c2_title8 c2_title">
                                    <div>RoSSo College</div>
                                </div>
                                <div class="c2_textBox">
                                    <div class="c2_text1">
                                        <h2>适合人群：</h2>
                                        <p>申请艺术院校的高中生</p>
                                    </div>
                                    <div class="c2_text2">
                                        <h2>课程详情：</h2>
                                        <ul>
                                            <li><span></span>全面发展，全科育人</li>
                                            <li><span></span>小班教学，因材施教</li>
                                            <li><span></span>在校即可完成作品集</li>
                                            <li><span></span>官方合作申请通道</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="c2_btn_box">
                                    <div class="c2_btn" @click="jopCourseDetail('/PortfolioInfo/RossoCollege.html')">
                                        <p>课程详情</p>
                                        <img src="../img/Frame2.png" alt="">
                                    </div>
                                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                                        <div class="c2_btn" style="background-color: #fb6333;">
                                            <p style="color: #fff;">预约试听</p>
                                            <img src="../img/Frame.png" alt="">
                                        </div>
                                    </a>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="swiper-pagination"></div>
                </div>

            </div>
        </div>

        <div class="courses3">
            <div class="section_box">
                <div class="section_title_cn">作品集辅导流程</div>
                <div class="section_title_en">PORTFOLIO PROCESS</div>
            </div>
            <div class="c3_cont">
                <div class="c3_item">
                    <img src="../img/艺术课程/Group 276.png" alt="">
                    <div class="c3_text">
                        <div class="c3_right_title">初期 / FIRSTSTEP</div>
                        <div class="c3_ul">
                            <div class="c3_li"><span></span>海归导师评估学生能力专业</div>
                            <div class="c3_li"><span></span>专业团队提供培训方案</div>
                            <div class="c3_li"><span></span>艺术教研团队审核方案</div>
                            <div class="c3_li"><span></span>作品集培训方案执行</div>
                        </div>
                    </div>
                </div>
                <div class="c3_item">

                    <div class="c3_text">
                        <div class="c3_right_title">中期 / SECONDSTEP</div>
                        <div class="c3_ul">
                            <div class="c3_li"><span></span>艺术基础课培训</div>
                            <div class="c3_li"><span></span>艺术专业课提升</div>
                            <div class="c3_li"><span></span>作品集1V1辅导</div>
                            <div class="c3_li"><span></span>跨学科思维植入</div>
                        </div>
                    </div>
                    <img src="../img/艺术课程/Group 277.png" alt="">
                </div>
                <div class="c3_item">
                    <img src="../img/艺术课程/Group 278.png" alt="">
                    <div class="c3_text">
                        <div class="c3_right_title">后期 / LASTSTEP</div>
                        <div class="c3_ul">
                            <div class="c3_li"><span></span>教研组作品集审核</div>
                            <div class="c3_li"><span></span>作品集优化提升</div>
                            <div class="c3_li"><span></span>招生官作品集审核</div>
                            <div class="c3_li"><span></span>作品集完成</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="courses4">
            <div class="section_box">
                <div class="section_title_cn">RoSSo独特四步教学法</div>
                <div class="section_title_en">RoSSo METHODS</div>
            </div>
            <div class="c4_cont">
                <div class="c4_item">
                    <div class="c4_left">
                        <div>LEVEL 1：</div>
                        <div>Universal</div>
                        <div>Cornerstones of Art</div>
                    </div>
                    <div class="c4_mid">1</div>
                    <div class="c4_right">
                        <div>艺术启发</div>
                        <div>基础先修课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left2">
                        <div>LEVEL 2：</div>
                        <div>Research and</div>
                        <div>Technique Exploration</div>
                    </div>
                    <div class="c4_mid">2</div>
                    <div class="c4_right">
                        <div>艺术探索</div>
                        <div>理论实践课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left3">
                        <div>LEVEL3：</div>
                        <div>Art and Design</div>
                        <div>Project Establishment</div>
                    </div>
                    <div class="c4_mid">3</div>
                    <div class="c4_right">
                        <div>艺术设计</div>
                        <div>项目核心课程</div>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_left c4_left4">
                        <div>LEVEL 4：</div>
                        <div>Art and Design</div>
                        <div>Project Specialization</div>
                    </div>
                    <div class="c4_mid">4</div>
                    <div class="c4_right">
                        <div>艺术设计</div>
                        <div>项目进阶课程</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="courses5">
            <div class="section_box">
                <div class="section_title_cn">多重五维RoSSo审核体系</div>
                <div class="section_title_en">COMPREHENSIVE AUDIT SYSTEM</div>
            </div>
            <div class="c5_cont">
                <div class="swiper mySwiperC2">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>1.专业审核 （初级考核）</h1>
                                    <p>主线导师指导下定制教学大纲。专业导师对每次课程作业和项目产出进行审核与把控</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 493.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>2.阶段性考核（期中考核）</h1>
                                    <p>还原海外授课模式，每2/3个月进行阶段性critique审核，训练学生面试的逻辑感和表达能力。</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 495.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>3.进阶项目提升</h1>
                                    <p>所属科系主管组织多名导师对学员产出进度和发展方向进行科系内审与评估，助力学员在后半程进阶提升；</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 496.jpg" alt="">
                            </div>

                        </div>
                        <div class="swiper-slide">
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>4. 教研终审</h1>
                                    <p>全国教研组对学员每个项目进行审核，采用海外名校考核维度与RoSSo多年教学经验相结合，提供更专业和客观的建议，严格把控作品质量；</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 498.jpg" alt="">
                            </div>
                            <div class="c5_item">
                                <div class="c5_left">
                                    <h1>5.名校教授审核</h1>
                                    <p>海外教授以真实的海外名校教学和审核体制为蓝本，对学员作品进行全面审核与评估，从经验和权威性等方面助力学员提升申请成功率。</p>
                                </div>
                                <img src="../img/艺术课程/Rectangle 499.jpg" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>

        </div>

        <div class="courses6">
            <div class="section_box">
                <div class="section_title_cn">RoSSo作品集课程优势</div>
                <div class="section_title_en">WHY CHOOSE RoSSO</div>
            </div>
            <div class="c6_cont">
                <div class="c6_item">
                    <div class="c6_textBox">
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>多对一教育体系</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>四级教学法</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>海外高等院校教学模式</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                    </div>
                    <img src="../img/艺术课程/Rectangle 528.jpg" alt="" class="c6_img1">
                </div>
                <div class="c6_item">
                    <img src="../img/艺术课程/Rectangle 527.jpg" alt="" class="c6_img2">
                    <div class="c6_textBox c6_textBox2">
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>多重五维审核体系</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>招生官艺术规划</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                        <div>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                            <p>VIP奖学金计划</p>
                            <img src="../img/艺术课程/Star 16.png" alt="">
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="section34 courses7">
            <div class="section_box">
                <div class="section_title_cn">优秀案例</div>
                <div class="section_title_en">SELECTED CASES</div>

            </div>
            <div class="s34_cont">
                <div class="swiper mySwiper333">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in selectedData">
                            <div class="s34_item" v-for="(item2, index2) in item">
                                <p class="s34_p1">RoSSo</p>
                                <img :src="'https://public.rossoarts.com/static/uploads/case/' + item2.portfolioShow"
                                    alt="">
                                <p class="s34_p2">{{ item2.name }}</p>
                                <p class="s34_p3">{{ item2.cname }}</p>
                                <p class="s34_p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>


                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>

        </div>

        <div class="section_inp">
            <div class="s_inp_left">
                <!-- <img src="../img/手部插画.png" alt="" class="img_shou animated" id="imgShou"> -->
                <img src="../img/Group 302.png" alt="" class="img_shou" id="imgText">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="1.2rem" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="预约校区：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="预约校区">
                            <el-option label="上海" value="shanghai"></el-option>
                            <el-option label="北京" value="beijing"></el-option>
                            <el-option label="南京" value="nanjing"></el-option>
                            <el-option label="成都" value="chengdu"></el-option>
                            <el-option label="杭州" value="hangzhou"></el-option>
                            <el-option label="广州" value="guangzhou"></el-option>
                            <el-option label="深圳" value="shenzhen"></el-option>
                            <el-option label="武汉" value="wuhan"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="输入电话号"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="意向专业：">
                        <el-input v-model="formLabelAlign.major" placeholder="意向专业"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>

        </div>
        <!-- 最外层div -->
    </div>
</template>
<script>
import "@/assets/css/courses.css"

import Swiper from 'swiper/bundle'
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axios from "axios"
export default {
    data() {
        return {
            selectedData: [],
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                major: '',
            },
            labelPosition: 'right',
        }
    },
    filters: {
        schoolSplit(val) {
            // const valLength = val.split("/").length
            // return valLength<2?val.split("/")[0]:val.split("/")[0] +"/" + val.split("/")[1]
            return val.split("/")[0]
        },
    },
    created() {
        this.getSelected()
    },
    methods: {
        jopCourseDetail(val) {
            this.$router.push(`${val}`)
        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google.com")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing.com")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo.com")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu.com")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "select_campus":this.formLabelAlign.region,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status": status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getSelected() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstCase?limit=24&page=1").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data, 4));
                this.selectedData = this.arrGroup(data.data, 4)
                this.$nextTick(() => {
                    this.mySwiper333Stick()
                })
            })
        },
        mySwiper333Stick() {
            var swiper = new Swiper(".mySwiper333", {
                pagination: {
                    clickable: true,
                    el: ".swiper-pagination",
                },
                loop: true,
                observer: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
    },
    mounted() {
        var swiper = new Swiper(".mySwiperC1", {
            // slidesPerView: 3,
            // spaceBetween: 30,
            // effect:'cube', 
            loop: true,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        var swiper = new Swiper(".mySwiperC2", {
            // slidesPerView: 3,
            // spaceBetween: 30,
            // effect:'cube', 
            loop: true,

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    },
    // beforeRouteEnter( to,from,next){
    //     console.log("yishu");
    // }

}
</script>
